import React from "react";
import Flex from "../../Flex";
import { Typography } from "../../Typography";
import * as S from "./styled";

type Props = {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    error?: React.ReactNode;
    disabled?: boolean;
    focused?: boolean;
    icon?: React.ReactNode;
    lead?: React.ReactNode;
    leadingEnhancement?: string;
    trail?: React.ReactNode;
    trailingEnhancement?: string;
    onClick?: (event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
    clear?: React.ReactNode;
};

export type TInputLikeProps = Partial<Props>;

const InputLike = React.forwardRef<HTMLLabelElement, Props>(
    (
        {
            className,
            style,
            error,
            disabled = false,
            focused = false,
            children,
            icon,
            lead = icon && <S.IconWrapper>{icon}</S.IconWrapper>,
            leadingEnhancement,
            trail,
            trailingEnhancement,
            clear,
            ...props
        },
        ref
    ) => {
        return (
            <S.InputLike
                ref={ref}
                className={className}
                style={style}
                $error={!!error}
                $disabled={disabled}
                {...(focused ? { "data-focused": focused } : {})}
                {...props}
            >
                {leadingEnhancement && (
                    <Flex
                        alignItems="center"
                        borderColor="primary-100"
                        borderStyle="solid"
                        borderWidth="0 1px 0 0"
                        column
                        justifyContent="center"
                        px={12}
                    >
                        <Typography color="primary-700" variant="paragraph-small-regular">
                            {leadingEnhancement}
                        </Typography>
                    </Flex>
                )}

                <Flex alignItems="center" gap={8} grow={1} justifyContent="space-between" px={12} py={8}>
                    {lead}
                    {children}
                    {clear}
                    {trail}
                </Flex>

                {trailingEnhancement && (
                    <Flex
                        alignItems="center"
                        borderColor="primary-100"
                        borderStyle="solid"
                        borderWidth="0 0 0 1px"
                        column
                        justifyContent="center"
                        px={12}
                    >
                        <Typography color="primary-700" variant="paragraph-small-regular">
                            {trailingEnhancement}
                        </Typography>
                    </Flex>
                )}
            </S.InputLike>
        );
    }
);

export default InputLike;
